import type { TableHeadCellProps } from 'src/components/table/components/head/table-head-custom';

import { useState, useEffect } from 'react';

export function usePersistedVisibleColumns(columns: TableHeadCellProps[], moduleName: string) {
  const [visibleColumns, setVisibleColumns] = useState<string[]>([]);

  // Initialize from props and localStorage
  useEffect(() => {
    if (columns) {
      const defaultIds = columns.map((col) => col.id);
      try {
        const saved = localStorage.getItem(`visibleColumns-${moduleName}`);
        if (saved) {
          setVisibleColumns(JSON.parse(saved));
        } else {
          setVisibleColumns(defaultIds);
        }
      } catch (e) {
        setVisibleColumns(defaultIds);
      }
    }
  }, [columns, moduleName]);

  // Persist changes
  const handleSetVisibleColumns = (newColumns: string[]) => {
    setVisibleColumns(newColumns);
    try {
      localStorage.setItem(`visibleColumns-${moduleName}`, JSON.stringify(newColumns));
    } catch (e) {
      console.error('Failed to save visible columns', e);
    }
  };

  return {
    visibleColumns,
    setVisibleColumns: handleSetVisibleColumns,
  };
}
